import styled, { keyframes, css } from "styled-components";
import { colors, spacing, radius } from "design-system/foundation";

// === Audio Player ===

export const PlayerContainer = styled.div`
  &,
  & *,
  & *::before,
  & *::after {
    box-sizing: border-box;
  }

  display: flex;
  flex-direction: row;
  align-items: center;
  gap: ${spacing.md};
  padding: ${spacing["2xl"]} ${spacing["2xl"]} ${spacing["2xl"]} ${spacing.xl};
  background: ${colors.bg.brand.secondarySoft};
  border-radius: ${radius.sm};
`;

export const PlayButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 64px;
  border: none;
  padding: ${spacing.none};
  background: ${colors.bg.base.default};
  cursor: pointer;
  flex-shrink: 0;
`;

export const WaveformContainer = styled.div<{ $visible: boolean }>`
  flex: 1;
  height: 35px;
  opacity: ${({ $visible }) => ($visible ? 1 : 0)};
  transition: opacity 0.2s ease;
`;

const equalizerPulse = keyframes`
  0% { height: var(--equalizer-first-height); }
  50% { height: var(--equalizer-second-height); }
  100% { height: var(--equalizer-first-height); }
`;

export const EqualizerContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-end;
  flex: 1;
  height: ${spacing["6xl"]};
  justify-content: space-between;
  gap: ${spacing["2xs"]};
  margin-left: ${spacing.md};
  padding: ${spacing.none} ${spacing.xs};
`;

export const EqualizerBar = styled.div<{
  $active: boolean;
  $firstHeight: number;
  $secondHeight: number;
  $duration: number;
}>`
  flex: 1;
  min-width: ${spacing["2xs"]};
  border-radius: ${spacing["2xs"]};
  background: ${({ $active }) =>
    $active ? colors.bg.brand.primaryBold : colors.bg.neutral.tertiary};
  transition: background 0.3s ease;

  ${({ $active, $firstHeight, $secondHeight, $duration }) =>
    $active
      ? css`
          --equalizer-first-height: ${$firstHeight}px;
          --equalizer-second-height: ${$secondHeight}px;
          animation: ${equalizerPulse} ${$duration}ms ease-in-out infinite;
        `
      : css`
          height: ${$firstHeight}px;
        `}
`;
